function findLocalStorage(param) {
  if (param === '') {
    return;
  }
  let ret = '';
  for (let i = 0; i < localStorage.length; i++) {
    if (localStorage.key(i).indexOf(param) !== -1) {
      ret = localStorage.getItem(localStorage.key(i));
      return ret;
    }
  }
  return ret;
}
export default findLocalStorage;
